import { u_ } from "@pressmedia/webappbase";
import moment from "moment";

export default {
	/**
	 * 設定情報のセッター
	 * @param {Object} conf
	 * @returns this
	 */
	setConfig(conf) {
		if( !u_.isObject(conf) ) {
			throw new TypeError("arguments[0] must be object.");
		}
		
		u_.isObject(this.configOverride) && Object.assign(conf, this.configOverride);
		
		Object.assign(this.config, conf);
		
		if( this.getDataKey() ) {
			!this.config.dateFormat && (this.config.dateFormat = "YYYY-MM-DD");
			!this.config.timeFormat && (this.config.timeFormat = "H:mm");
			if(this.config.fileDir) {
				this.config.fileDir = this.config.fileDir.replace(
					/^\{root\}/,
					this.app._relativePath
				);
			}
			
			// for wysiwyg
			this.wysiwyg.ready.call(this);
		}
		
		return this;
	},
	
	/**
	 * 設定情報の読み込み
	 * @param {Object} reqData: request data object
	 * @param {Function} cb: callback function (@arg1: err, @arg2: responce)
	 * @returns {Promise}
	 */
	async loadConfig(reqData, cb) {
		const methodName = "loadConfig";
		
		if( !u_.isObject(reqData) ) {
			u_.isFunction(reqData) && (cb = reqData);
			reqData = undefined;
		}
		
		// [send request]
		return this._sendRequest(methodName, {
			endPoint: "config",
			data: reqData
		}, (err, res) => {
			if(!err) {
				this.setConfig(res.config);
				!!res.now && ( this.app.now = moment(res.now) );
			}
			return !u_.isFunction(cb) || cb(err, res);
		});
	}
};
